<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <status-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import TitleCard from '@/views/Defines/Product_categories/Elements/TitleCard.vue'
import StatusCard from '@/views/Defines/Product_categories/Elements/StatusCard.vue'

export default {
  name: 'ItemForm',
  components: {
    TitleCard,
    StatusCard,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
}
</script>
